<template>
  <div>
    <div class="authenticated">
      <b-navbar toggleable="md" fixed="top" type="dark" variant="info">

        <b-navbar-brand v-on:click="buttonTypeMenu('/accueil')">AboRacco <div class="version">2026.42.1</div></b-navbar-brand>
        <b-nav-toggle target="nav_collapse"></b-nav-toggle>

        <b-collapse is-nav id="nav_collapse">

          <b-navbar-nav>
            <router-link class="nav-link" to="/interventions/prod/open">Production</router-link>
            <router-link class="nav-link" to="/interventions/postprodsav/open">Post-Production / SAV</router-link>
            <router-link class="nav-link" to="/interventions/audit/open">Audit</router-link>
            <router-link class="nav-link" to="/testarbre">Test des arbres</router-link>
            <router-link class="nav-link" to="/account">Mon compte</router-link>
            <!--<router-link class="nav-link" to="/scan">Scan ONU</router-link>-->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    }
  },
  methods: {
    buttonTypeMenu: function (status) {
      this.$router.push(status)
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue